





































































































import { RootAction, Action } from '@/features/core/store';
import { AddToastMessageParams } from '@/features/core/store/toast';
import { StringProp } from '@/util/prop-decorators';
import download from 'downloadjs';
import moment from 'moment';
import QRCode from 'qrcode';
import { Component, Mixins } from 'vue-property-decorator';
import { NotificationsMixin } from '@/features/core/components/mixins/notifications/notifications';
import query from './spot.gql';
import { Option } from '@/features/ui/inputs/model';
import {
  AppManagerTreeNodeSpotDetailsSpotViewQuery,
  AppManagerTreeNodeSpotDetailsSpotViewQueryVariables,
} from './__generated__/AppManagerTreeNodeSpotDetailsSpotViewQuery';
import { MetricResolutionAggregator } from '@/types/iot-portal';

@Component({
  apollo: {
    spots: {
      query,
      fetchPolicy: 'no-cache',
      pollInterval: 60000,
      variables(): AppManagerTreeNodeSpotDetailsSpotViewQueryVariables {
        return { spotId: this.spotId, take: this.take, skip: this.skipAlerts, activeOnly: this.activeOnly };
      },
    },
  },
  data() {
    return {
      spots: undefined,
      selectedMetrics: [],
      availableOnGraphMetrics: [],
      startDate: moment().subtract(30, 'days').startOf('day').toDate(),
      stopDate: moment().toDate(),
      aggregationInterval: undefined,
      qrCode: undefined,
      aggregator: undefined,
    };
  },
})
export default class SpotView extends Mixins(NotificationsMixin) {
  @StringProp(true)
  private readonly treeNodeId!: string;

  @StringProp(true)
  private readonly spotId!: string;

  @RootAction
  private readonly ADD_TOAST_MESSAGES!: Action<AddToastMessageParams, void>;

  private readonly spots?: AppManagerTreeNodeSpotDetailsSpotViewQuery['spots'];

  private activeOnly = true;

  private readonly activeOptions: Option[] = [
    { value: true, label: 'Aktive' },
    { value: false, label: 'Alle' },
  ];

  private selectedMetrics!: string[];
  private availableOnGraphMetrics!: string[];
  private aggregator?: MetricResolutionAggregator;
  private startDate!: Date;
  private stopDate?: Date;
  private aggregationInterval?: Duration;
  private qrCode?: string;

  private currentPageNotifications = 1;

  private currentPageAlerts = 1;

  protected get totalPagesNotifications(): number {
    return Math.max(1, Math.ceil((this.notifications?.count ?? 0) / this.take));
  }

  protected get more(): boolean | undefined {
    return this.spots?.first.alerts.more ?? false;
  }

  protected get totalPagesAlerts(): number {
    return this.currentPageAlerts + Number(this.more);
  }

  protected get skip(): number {
    return (this.currentPageNotifications - 1) * this.take;
  }

  protected get skipAlerts(): number {
    return (this.currentPageAlerts - 1) * this.take;
  }

  protected get take(): number {
    return 5;
  }

  protected get contextIds(): string[] {
    return [this.spotId];
  }

  private async onReloadClick(): Promise<void> {
    this.currentPageNotifications = 1;

    await this.refetchNotifications();
  }

  private downloadQrCode(): void {
    if (this.qrCode === undefined) {
      return;
    }

    download(this.qrCode, `qr-code-spot-${this.spotId}.png`);
  }

  private async generateQr(show: () => Promise<void>): Promise<void> {
    try {
      this.qrCode = await QRCode.toDataURL(`${window.location.origin}/manager/${this.treeNodeId}/spot/${this.spotId}`);
      await show();
    } catch (error) {
      // eslint-disable-next-line no-console -- dont swallow errors
      console.error(error);

      this.ADD_TOAST_MESSAGES({ messages: [{ text: 'QR-Code konnte nicht generiert werden', class: 'error' }] });
    }
  }
}
